
/************************
 * Sidemenu Click-Events *
 *************************/

/* Toggle show */
$(document).ready(function() {
  var initJSPbyShhow = false;
  $(".toggle_side_menu, .toggle_xs_menu").click(function() {
    $("#jspwrap").animate(
      {
        width: "toggle"
      },
      300,
      function() {
        if (!initJSPbyShhow) {
          // $('.scroll-pane').jScrollPane();
          initJSPbyShhow = true;
        }
      }
    );

    // $('.preview_box_collection_slider_slick_slider').on('lazyLoaded', function (evt, slick, $img) {

    //   $img
    //     // Find the parent <picture> tag of img
    //     .closest('picture')
    //     // Find <source> tags with data-lazy-srcset attribute
    //     .find('source[data-lazy-srcset]')
    //     // Copy data-lazy-srcset to srcset
    //     .each(function (i, source) {
    //       $source = $(source);
    //       $source.attr('srcset', $source.data('lazy-srcset'));
    //     });

    // });
  });

  var reviewCount = $("#review-inner-container .review:visible").length;
  //   console.log(reviewCount);

  $("body.home #more-reviews").click(function() {
    $($("#review-inner-container .review")[reviewCount]).css(
      "display",
      "block"
    );
    $($("#review-inner-container .review")[reviewCount + 1]).css(
      "display",
      "block"
    );
    $("#review-inner-container .review tspan").attr("dy", "10.5");
    reviewCount += 2;
  });

  $(".preview_box_collection_slider_slick_slider").on("lazyLoaded", function(
    evt,
    slick,
    $img
  ) {
    // console.log("lazy-srcset");
    $img
      // Find the parent <picture> tag of img
      .closest("picture")
      // Find <source> tags with data-lazy-srcset attribute
      .find("source[data-lazy-srcset]")
      // Copy data-lazy-srcset to srcset
      .each(function(i, source) {
        $source = $(source);
        $source.attr("srcset", $source.data("lazy-srcset"));
      });
  });
});

$(".close_sidebar_click").click(function() {
  $("#jspwrap").animate({width: "toggle"}, 300);
});

/* Store status */
$(".side_menu .menu-item a").click(function() {
  store_side_menu_status("show");
});

/* MixItUp */
if (jQuery().mixItUp) {
  $("#mix_container").mixItUp();
} else {
}

/* set sidemenu classes */
set_sidemenu_classes();

/* Newsletter Placeholder */
$("#input_5_1").attr("placeholder", "Ihre E-Mail-Adresse");

/* check side menu status
	if (localStorage.getItem("sidemenu") == 'show') {
		$('#jspwrap').show();
		$('.scroll-pane').jScrollPane();
		store_side_menu_status('hide');
	}
  */

/* Toggle Submenu */
$(".before_list").click(function() {
  $(this)
    .siblings("ul")
    .toggle("slow", function() {
      // $('.scroll-pane').jScrollPane();
    });

  if ($(this).html() == " +") {
    $(this).html(" -");
  } else {
    $(this).html(" +");
  }
});

/* Royal Slider */
if ($("body").hasClass("page-start") || $("body").hasClass("home")) {
  $(".header_slider").royalSlider({
    controlNavigation: "none",
    imageScaleMode: "fill",
    autoScaleSlider: true,
    autoScaleSliderHeight: 775,
    autoScaleSliderWidth: 1920,
    arrowsNav: false,
    slidesSpacing: 0,
    loop: true,
    autoPlay: {
      // autoplay options go gere
      enabled: true,
      pauseOnHover: true,
      delay: 7500
    },
    imageAlignCenter: false
  });

  var slider = $(".header_slider").data("royalSlider");

  $(".slider_nav_l").click(function() {
    slider.prev();
  });

  $(".slider_nav_r").click(function() {
    slider.next();
  });

  slider.ev.on("rsAfterContentSet", function(e, slideObject) {
    // fires when every time when slide content is loaded and added to DOM
    var $bild = $(".header_slider img").first();
    $bild.attr("src", $bild.data("original"));
  });

  var isLoaded = false;
  slider.ev.on("rsBeforeAnimStart", function(event) {
    if (!isLoaded) {
      $(".header_slider img").each(function(i, source) {
        $source = $(source);
        $source.attr("src", $source.data("original"));
      });
    }
  });
}

/* Startimages Hover */
$(".img_sleep").hover(
  function() {
    $(".teaser_sleep").css("background-color", "#dbefb4");
  },
  function() {
    $(".teaser_sleep").css("background-color", "#fff");
  }
);

$(".img_erholen").hover(
  function() {
    $(".teaser_erholen").css("background-color", "#dbefb4");
  },
  function() {
    $(".teaser_erholen").css("background-color", "#fff");
  }
);

$(".img_golfen").hover(
  function() {
    $(".teaser_golfen").css("background-color", "#dbefb4");
    $(".arrow_right_container").addClass("green_right_arrow");
  },
  function() {
    $(".teaser_golfen").css("background-color", "#fff");
    $(".arrow_right_container").removeClass("green_right_arrow");
  }
);

$(".img_essen").hover(
  function() {
    $(".teaser_essen").css("background-color", "#dbefb4");
    $(".arrow_right_container").addClass("green_right_arrow");
  },
  function() {
    $(".teaser_essen").css("background-color", "#fff");
    $(".arrow_right_container").removeClass("green_right_arrow");
  }
);

/* Add lightbox class to all <a> with direct <img> */
$("a:has(> img)").addClass("lightbox");

$("a:has(> .vc_single_image-wrapper > img)").addClass("lightbox");

var overlayOn = function() {
  $('<div id="imagelightbox-overlay"></div>').appendTo("body");
};

var overlayOff = function() {
  $("#imagelightbox-overlay").remove();
};

/* initiate lightbox */
$("a.lightbox").imageLightbox({
  onStart: function() {
    overlayOn();
  },
  onEnd: function() {
    overlayOff();
  }
});

$(".vorteile_xs").click(function() {
  $(".start_vorteile").animate({height: "toggle"}, 500);
});

/* Toggle Searchform */
$(".toggle_search_on").click(function() {
  $("#meta_nav_header").toggle(400, function() {
    $(".search_form_header").toggle(400);
  });
});

$(".toggle_search_off").click(function() {
  $(".search_form_header").toggle(400, function() {
    $("#meta_nav_header").toggle(400);
  });
});

/* toggle Tagunsraeume */
$(".toggle_0").click(function() {
  $(".tr_0").animate({height: "toggle"}, 500);
});
$(".toggle_1").click(function() {
  $(".tr_1").animate({height: "toggle"}, 500);
});
$(".toggle_2").click(function() {
  $(".tr_2").animate({height: "toggle"}, 500);
});
$(".toggle_3").click(function() {
  $(".tr_3").animate({height: "toggle"}, 500);
});
$(".toggle_4").click(function() {
  $(".tr_4").animate({height: "toggle"}, 500);
});

/* Buchen XS */
$(".menu_xs_icon_wrap_buchen").click(function() {
  document.location.href = "/wbe5";
});

/* News & event Tab */
$(".news_events_tab").click(function() {
  if ($(this).hasClass("tab_active")) {
    return;
  } else {
    $(".news_events_tab").toggleClass("tab_active arrow_box_down");
    $(".news_tab").toggleClass("hide_tab");
  }
});



/* Google Maps */
var map;
window.loadHeaderMap = function() {
  if (document.getElementById("map-canvas")) {


    // Coordinates to center the map
    var myLatlng = new google.maps.LatLng(54.10613, 13.103185);
    var center = new google.maps.LatLng(53.83411, 12.136639);

    // Other options for the map, pretty much selfexplanatory
    var mapOptions = {
      zoom: 9,
      center: center,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    // Attach a map to the DOM Element, with the defined settings
    map = new google.maps.Map(
      document.getElementById("map-canvas"),
      mapOptions
    );

    var marker = new google.maps.Marker({
      position: myLatlng,
      map: map,
      title: "Golfpark Strelasund"
    });

    var infowindow = new google.maps.InfoWindow({
      content: "Golfpark <br/> Strelasund"
    });

    marker.setMap(map);
    google.maps.event.addListener(marker, "click", function() {
      infowindow.open(map, marker);
    });
  }
};
// window.onload = function() {

// };

/* toogle Map header */
$(".toggle_map").click(function() {

  google.maps.event.trigger(map, 'resize');
 // alert("Debug");

  loadHeaderMap();
  $("#map_slide_wrapper").animate({height: "toggle"}, 500);

  jQuery(".mapscontainer").slideToggle("slow");
  center = map.getCenter();
  google.maps.event.trigger(map, "resize");
  map.setCenter(center);
});

$(".toggle_maps_kontakt").click(function() {
  loadHeaderMap();
  google.maps.event.trigger(map, 'resize');

  $("html, body").animate({scrollTop: 0}, "slow");
  $("#map_slide_wrapper").animate({height: "toggle"}, 500);
  jQuery(".mapscontainer").slideToggle("slow");

  center = map.getCenter();
  google.maps.event.trigger(map, "resize");
  map.setCenter(center);
  if (
    $(".toggle_maps_kontakt").html() == "Golfpark Strelasund auf Google Maps"
  ) {
    $(".toggle_maps_kontakt").html("Katrte schließen & Menü wieder anzeigen");
  } else {
    $(".toggle_maps_kontakt").html("Golfpark Strelasund auf Google Maps");
  }
});

/* use local storage to display side menu */
function store_side_menu_status(status) {
  if (typeof Storage !== "undefined") {
    localStorage.setItem("sidemenu", status);
  } else {
    return false;
  }
}

/* set sidemenu classes */
function set_sidemenu_classes() {
  $(".side_menu .menu-item-has-children > a").before(
    '<span class="before_list before_list_plus"> +</span>'
  );

  $(".side_menu .current-menu-item.menu-item-has-children ")
    .children("span")
    .html(" -");

  $(".side_menu .current-page-ancestor")
    .children("span")
    .html(" -");
}

/* Aktionsleiste */
$(function() {
  /* WICHTIG: initialisiere die Leiste */
  initVimindsLeiste();
});

function initVimindsLeiste(id, scrollTopValue, close_id, zipfel_id, speed) {
  /* ==========================================================================
   Standardwerte
   ========================================================================== */
  if (typeof id == "undefined") {
    id = "viminds_leiste";
  }
  if (typeof scrollTopValue == "undefined") {
    scrollTopValue = 250;
  }
  if (typeof close_id == "undefined") {
    close_id = "viminds_leiste_close";
  }
  if (typeof zipfel_id == "undefined") {
    zipfel_id = "viminds_leiste_zipfel";
  }
  if (typeof speed == "undefined") {
    speed = 500;
  }

  var leiste = $("#" + id);
  var close_button = $("#" + close_id);
  var zipfel = $("#" + zipfel_id);

  /* ==========================================================================
      Fly in after X Seconds
      ========================================================================== */

  if (typeof $.cookie("vimindsLeiste") == "undefined") {
    setTimeout(function() {
      if (!leiste.is(":visible")) {
        // l("slideUp!");
        leiste.stop(true, true).animate(
          {
            height: "60px",
            opacity: "toggle"
          },
          speed
        );
      }
    }, 5000);
  } else if ($.cookie("vimindsLeiste") != "undefined") {
    changeToOrange(leiste, close_button);
    leiste.show().css("height", "5px");
    zipfel
      .show()
      .css("bottom", "0")
      .css("height", "60px");
  }

  /* ==========================================================================
      Close Events
      ========================================================================== */
  // close button click
  close_button.click(function() {
    leiste.stop(true, true).animate(
      {
        height: "0"
      },
      500,
      function() {
        changeToOrange(leiste, close_button);
        // leiste.hide();
        $.cookie("vimindsLeiste", "off", {expires: 30, path: "/"});

        animateZipfelFlyIn(leiste, zipfel);
      }
    );
  });

  // blende wieder leiste ein (zipfel click)
  zipfel.click(function() {
    zipfel.animate(
      {
        height: "0"
      },
      speed,
      function() {
        leiste.animate(
          {
            height: "0"
          },
          10,
          function() {
            resetStylings(leiste, close_button);
            leiste.show().animate(
              {
                height: "60px"
              },
              speed,
              function() {
                $.removeCookie("vimindsLeiste", {path: "/"});
              }
            );
          }
        );
      }
    );
  });

  function changeToOrange(leiste, close_button) {
    leiste
      .css("backgroundColor", "rgba(133,178,0,0.9)")
      .css("backgroundImage", "none");
    close_button.css("backgroundColor", "rgba(133,178,0,0.9)");
  }

  function resetStylings(leiste, close_button) {
    leiste.attr("style", "");
    close_button.attr("style", "");
  }

  function animateZipfelFlyIn(leiste, zipfel) {
    leiste.animate(
      {
        height: "5px"
      },
      200
    );
    // Zipfel einblenden
    zipfel.show().animate(
      {
        height: "60px",
        bottom: "0"
      },
      speed
    );
  }
}
